export default function Problems() {
  const problems = [
    {
      icon: 'ri-emotion-unhappy-line',
      title: '人前で笑うのが恥ずかしい',
      description: '写真を撮る時、つい口を閉じてしまう。友人との食事会でも、歯並びが気になって心から楽しめない。',
      color: 'from-rose-500 to-pink-500',
      image: 'https://public.readdy.ai/ai/img_res/9a89392096976a7978fecb687cb33513.jpg'
    },
    {
      icon: 'ri-time-line',
      title: '子供の頃にできなかった後悔',
      description: '親に言えなかった、経済的に難しかった。あの時やっておけば…という思いが今も心に残っている。',
      color: 'from-amber-500 to-orange-500',
      image: 'https://readdy.ai/api/search-image?query=A%20Japanese%20woman%20in%20her%2040s%20looking%20at%20old%20childhood%20photos%20with%20a%20nostalgic%20and%20regretful%20expression%2C%20soft%20warm%20lighting%2C%20clean%20modern%20interior%20background%20in%20soft%20amber%20and%20white%20tones%2C%20emotional%20moment%20reflecting%20on%20past%20decisions%2C%20professional%20lifestyle%20photography&width=600&height=400&seq=problem-2&orientation=landscape'
    },
    {
      icon: 'ri-eye-line',
      title: '矯正器具が目立つのが嫌',
      description: '仕事柄、見た目が大切。金属の矯正器具をつけるのは抵抗がある。周りの目が気になって踏み出せない。',
      color: 'from-indigo-500 to-purple-500',
      image: 'https://readdy.ai/api/search-image?query=A%20professional%20Japanese%20woman%20in%20her%2030s%20in%20a%20business%20meeting%20or%20office%20setting%20looking%20self-conscious%2C%20soft%20professional%20lighting%2C%20modern%20office%20background%20in%20soft%20indigo%20and%20white%20tones%2C%20expressing%20concern%20about%20appearance%20at%20work%2C%20professional%20business%20photography&width=600&height=400&seq=problem-3&orientation=landscape'
    }
  ];

  return (
    <section id="problems" className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            こんなお悩み、<br />
            <span className="text-teal-600">ありませんか?</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            多くの女性が、同じ悩みを抱えています
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {problems.map((problem, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 group">
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={problem.image} 
                  alt={problem.title} 
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className={`absolute inset-0 bg-gradient-to-br ${problem.color} opacity-20`}></div>
              </div>
              <div className="p-8">
                <div className={`inline-flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-br ${problem.color} shadow-lg mb-4`}>
                  <i className={`${problem.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{problem.title}</h3>
                <p className="text-gray-600 leading-relaxed">{problem.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-block bg-teal-50 rounded-2xl p-8 max-w-3xl">
            <p className="text-lg text-gray-700 leading-relaxed">
              <strong className="text-teal-600">でも、もう大丈夫です。</strong><br />
              透明なマウスピース矯正なら、これらの悩みをすべて解決できます。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}